import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateInvoiceSchema } from "@/v2/schema/invoice";
import { Invoice } from "@/v2/types";

export default async function CreateInvoice(
    data: CreateInvoiceSchema,
): Promise<Invoice> {
    const formData = new FormData();

    if (data.client_id) {
        formData.append("client_id", data.client_id);
    }
    if (data.supplier_id) {
        formData.append("supplier_id", data.supplier_id);
    }
    formData.append("completed", String(data.completed));

    formData.append("invoice_number", data.invoice_number);
    formData.append("invoice_amount", String(data.invoice_amount));
    formData.append("invoice_vat", String(data.invoice_vat));
    if (data.invoice_due_date) {
        formData.append("invoice_due_date", String(data.invoice_due_date));
    }
    formData.append("invoice_date", data.invoice_date);
    if (data.invoice_paid) {
        formData.append("invoice_paid", data.invoice_paid);
    }

    formData.append("invoice_due_period", data.invoice_due_period);
    formData.append("type", data.type);
    if (data?.invoice_receipt && data.invoice_receipt.length > 0)
        formData.append("file", data.invoice_receipt[0]);

    formData.append("invoice_paid_amount", String(data.invoice_paid_amount));

    if (data?.months_and_year_against_time_sheet)
        formData.append(
            "months_and_year_against_time_sheet",
            data.months_and_year_against_time_sheet,
        );

    if (data?.reference_number)
        formData.append("reference_number", data.reference_number);

    const res = await apiClientWithRefreshToken({
        url: "/invoices",
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data: formData,
    });
    return res.data;
}
